// eslint-disable-next-line react/jsx-curly-newline
import React from "react";

const FAQSpanish = (props) => (
  <div>
    <h3>¿Cuál es la cuota anual de membresía de AuctionACCESS?</h3>
    <p className="faq">
      La cuota anual de membresía de AuctionACCESS es ${props.amount} por cada individuo. La
      membresía facilita la acreditación en mas de 320 mercados de subastas en
      Estados Unidos y Canadá.
    </p>
    <h3>¿Como puedo pagar mi membresía?</h3>
    <p className="faq">
      La membresía se puede pagar con tarjeta de crédito, tarjeta de debito, o
      ACH ingresando su información a la derecha. También puede ingresar a su
      cuenta en AuctionACCESS.com para renovar múltiples membresías si es
      propietario o funcionario autorizado.
    </p>
    <p className="faq">
      Para más información en membresías, por favor visite nuestra página de
      <a href="https://www.auctionaccess.com/faq/"> Preguntas más frecuentes.</a>
    </p>
  </div>
);

export default FAQSpanish;
